module.exports = __webpack_public_path__ + "static/media/favicon.698ffd8b.ico";